var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderMyProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75012 22.0001C5.32658 21.3545 8.02643 18.3835 8.81763 18.3835H17.1831C18.3296 18.3835 20.6701 20.8462 21.2501 21.7144M25.0001 13.0001C25.0001 19.6275 19.6275 25.0001 13.0001 25.0001C6.37271 25.0001 1.00012 19.6275 1.00012 13.0001C1.00012 6.37271 6.37271 1.00012 13.0001 1.00012C19.6275 1.00012 25.0001 6.37271 25.0001 13.0001ZM17.2987 8.91007C17.2987 6.62068 15.366 4.75012 13.0005 4.75012C10.635 4.75012 8.70229 6.62068 8.70229 8.91007C8.70229 11.1995 10.635 13.07 13.0005 13.07C15.366 13.07 17.2987 11.1995 17.2987 8.91007Z",
    stroke: "#42485A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderMyProfile);
export default __webpack_public_path__ + "static/media/Icon-Header-My_profile.3ac7d5e27bedd7c0f8c3472387b8d098.svg";
export { ForwardRef as ReactComponent };